import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// Utils
import { useSetState } from 'utils';
import { timeFormatter } from 'utils/global';
// Auth Context
import { useAuthDispatch } from 'context/AuthContext';
import { initialiseGoogleLogout } from 'context/AuthContext/middleware';
// Production Context
// import { useProductionState } from 'context/ProductionContext';
// Components
import ApplicationStatus from 'components/ApplicationStatus';
// Styles
import styles from './style/logoutTimer.module.css';

function LogoutTimer({ time }: { time: string }) {
  const location = useLocation();
  const savedCallback = useRef<Function>();
  // Auth Context
  const authDispatch = useAuthDispatch();
  // Production Context
  // const { productionState } = useProductionState();
  // State
  const [state, setState] = useSetState({
    remaining: null,
    timer: Date.now() + time,
    timingOut: false,
  });

  function initiateLogoutTimer() {
    function tick() {
      if (savedCallback.current) {
        savedCallback.current();
      }
    }
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }

  function logoutCallback() {
    const startDate = new Date();
    const endDate = new Date(state.timer);
    const remainingTime = timeFormatter(startDate, endDate);
    if (!remainingTime) {
      setTimeout(() => {
        initialiseGoogleLogout(authDispatch);
      }, 1000); 
    }
    setState({
      remaining: remainingTime || 'Logging out',
      timingOut: (Number(endDate) - Number(startDate)) < 300000,
    });
  }

  function setSavedCallback() {
    savedCallback.current = logoutCallback;
  }

  useEffect(() => {
    setState({
      remaining: null,
      timer: Date.now() + time,
      timingOut: false,
    });
  }, [location, setState, time]);

  useEffect(initiateLogoutTimer, []);
  useEffect(setSavedCallback);

  return (
    <>
      { state.timingOut ? (
        <div className={styles.logoutTimer} data-automation-id="sign-out">
          Logout in: {state.remaining}
        </div>
      ) : (
        <ApplicationStatus />
      )}
    </>
  );
}

export default LogoutTimer;
